import { DateTime } from 'luxon';
import Vue from 'vue';
// Vue.filter('ucwords', (str: string) => ucwords(str));
// Vue.filter('secondsToDays', (value: any) => {
//   if (! value || ! Number.isInteger(value)) {
//     return '-';
//   }
//   const totalDays = Math.floor(value / 24 / 60);
//   const dayString = totalDays === 1 ? 'day' : 'days';
//   return `${totalDays} ${dayString}`;
// });
// Vue.filter('hours', (value: any) => new Intl.NumberFormat('nl-NL', {
//   minimumFractionDigits: 2,
//   maximumFractionDigits: 2,
// }).format(value));
// Vue.filter('dateFormatTime', (date: string) => {
//   if (date === '-') {
//     return '-';
//   }
//   if (! date) {
//     return '';
//   }
//   if (! DateTime.fromSQL(date).isValid) { return '-'; }
//   return DateTime.fromSQL(date).toFormat('yyyy-LL-dd HH:mm:ss');
// });
// Vue.filter('formatTime', (date: string) => {
//   if (date === '-') {
//     return '-';
//   }
//   if (! date) {
//     return '';
//   }
//   if (! DateTime.fromSQL(date).isValid) { return '-'; }
//   return DateTime.fromSQL(date).toFormat('HH:mm');
// });
Vue.filter('formatDate', (date) => {
    if (!date) {
        return '';
    }
    if (!DateTime.fromSQL(date).isValid) {
        return '-';
    }
    return DateTime.fromSQL(date).toFormat('dd-LL-yyyy');
});
// Vue.filter('lower', (value: string) => {
//   if (! value) {
//     return '';
//   }
//   return value.toLowerCase();
// });
// Vue.filter('capitalize', (value: string) => {
//   if (! value) {
//     return '';
//   }
//   return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
// });
